









import { AppModule } from '@/store/modules/app'
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
/* import EventBus from '@/utils/eventBus' */
@Component({
  name: "book-preview"
})
export default class Preview extends Vue{
    @Prop() private active!: boolean
    
    get hidePreviewButton() {
        return AppModule.hidePreviewButton
    }

    openPreview() {
        AppModule.SetShowPreview(true);
        (document.body as HTMLElement).style.overflow="hidden";
        /* EventBus.$emit('PREVIEW_OPEN') */
    }

    matomoEvent() {
      const step = this.$store.getters.activeStepComponent || 'start';
      return `${this.$route.name}_${step};btnPreview`;
    }
}
